import { Auth, api } from '../../api';
import { ApiRoutes } from '../../api/api-routes.enum';
import { DeleteUserResponse } from '../../api/responses/delete-user.response';
import { GetUsersResponse } from '../../api/responses/get-users.response';
import { PostUserResponse } from '../../api/responses/post-user.response';
import { GetManyParams } from '../../api/responses/template/get-many.template';
import { Toast } from '../../enum/toast.enum';
import { NewUser } from '../../types/new-user.interface';
import { SignIn } from '../../types/signin.interface';
import { Role, User } from '../../types/user.interface';
import { setAuthorized, setUser } from '../slices/user';
import { AppThunk } from '../store';
import { withLoading } from './withLoading';

export const signInThunk = ({
  email,
  password,
}: SignIn): AppThunk => dispatch =>
  dispatch(
    withLoading(async () => {
      const res = await Auth.signIn({ email, password });
      dispatch(setAuthorized(true));
      dispatch(setUser(res.data.user));
    }, 'Неправильный email и/или пароль. Попробуйте еще раз.'),
  );

export const getRolesThunk = (): AppThunk<
  Promise<Role[] | void>
> => async dispatch => {
  return dispatch(
    withLoading<Role[]>(async () => {
      const { data } = await api.get<Role[]>(ApiRoutes.roles);
      return data;
    }, Toast.getRolesError),
  );
};

export const getUsersThunk = (
  params?: GetManyParams,
): AppThunk<Promise<GetUsersResponse | void>> => async dispatch => {
  return dispatch(
    withLoading<GetUsersResponse>(async () => {
      const { data } = await api.get<GetUsersResponse>(
        `${ApiRoutes.user}/all`,
        { params },
      );
      return data;
    }),
  );
};

export const getCurrentUserThunk = (
  id: string,
): AppThunk<Promise<User | void>> => async dispatch => {
  return dispatch(
    withLoading<User>(async () => {
      const { data } = await api.get<User>(`${ApiRoutes.user}/${id}`);
      return data;
    }),
  );
};

export const postUserThunk = (
  user: NewUser,
): AppThunk<Promise<PostUserResponse | void>> => async dispatch => {
  return dispatch(
    withLoading<PostUserResponse>(async () => {
      const { data } = await api.post<PostUserResponse>(
        ApiRoutes.createUser,
        user,
      );
      return data;
    }, Toast.postUserError),
  );
};

export const putUserThunk = (
  user: NewUser,
  id: string,
): AppThunk<Promise<PostUserResponse | void>> => async dispatch => {
  return dispatch(
    withLoading<PostUserResponse>(async () => {
      const { data } = await api.put<PostUserResponse>(
        `${ApiRoutes.user}/${id}`,
        user,
      );
      return data;
    }, Toast.postUserError),
  );
};

export const deleteUserThunk = (
  id: string,
): AppThunk<Promise<DeleteUserResponse | void>> => async dispatch => {
  return dispatch(
    withLoading<DeleteUserResponse>(async () => {
      const { data } = await api.post<DeleteUserResponse>(
        `${ApiRoutes.user}/${id}/remove`,
      );
      return data;
    }, Toast.deleteUserError),
  );
};

export const resetUserPasswordThunk = (
  id: string,
): AppThunk<Promise<User | void>> => async dispatch => {
  return dispatch(
    withLoading<User>(async () => {
      const { data } = await api.post<User>(
        `${ApiRoutes.user}/${id}/password/reset`,
      );
      return data;
    }, Toast.resetPasswordError),
  );
};
